import { useState } from 'react'

type SelectedEvent = { agendaId: string; eventId: string }

export const useEventModals = () => {
  const [selectedEvent, setSelectedEvent] = useState<SelectedEvent | null>(null)
  const [newEventOpen, setNewEventOpen] = useState(false)

  const openEvent = (agendaId: string, eventId: string) => {
    setSelectedEvent({ agendaId, eventId })
  }

  const closeEvent = () => setSelectedEvent(null)

  return {
    selectedEvent,
    newEventOpen,
    setNewEventOpen,
    openEvent,
    closeEvent,
  }
}
